<template>
  <el-dialog
    :key="formKey"
    v-dialogDrag
    title="钉钉账号"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    custom-class="self-dialog-form"
    width="800px"
  >
    <!-- 表格操作按钮 -->
    <!-- 表格 -->
    <EdmCustomTable
      ref="EdmCustomTable"
      :loading="tableLoading"
      :table-data="tableData"
      :show-pagination="false"
      :checkbox="true"
    >
      <el-table-column
        v-for="(cm, index) in tableColumns"
        :key="cm.name"
        :label="cm.name"
        :index="index"
        :width="cm.width"
        :fixed="cm.fixed"
        :min-width="100"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{ scope.row}}
        </template>
      </el-table-column>
    </EdmCustomTable>
    <!-- /表格 -->
    <span slot="footer" class="dialog-footer">
      <el-button plain @click="dialogVisible = false">
        {{ $t('public.cancel') }}
      </el-button>
      <el-button type="primary" @click="unBind">
        解绑
      </el-button>
    </span>
    <delete-dialog
      layout="left"
      :visible.sync="unBindTipVisible"
      :content="unBindTipLoadingContent"
      :loading.sync="unBindTipLoading"
      @confirm="handleDeleteConfirm"
    />
  </el-dialog>
</template>

<script>
import userApi from "@/api/user/user";
import DeleteDialog from "@/components/common/Dialogs/DeleteDialog";
export default {
  name: "DdBindUser",
  components: {
    DeleteDialog
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    propData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      formKey: new Date().getTime(),
      tableLoading: false,
      tableColumns: [
        {
          name: "钉钉id",
          field: "displayName",
          width: "auto",
          fixed: false
        }
      ],
      tableData: [],
      unBindTipVisible: false,
      unBindTipLoading: false,
      unBindTipLoadingContent: {
        title: "提示信息",
        description: `您确定解除此账号的钉钉绑定吗？`
      }
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  created() {
    this.getList();
  },
  methods: {
    handleDeleteConfirm() {
      const checkedArr = this.$refs.EdmCustomTable.getChecked();
      this.unBindTipLoading = true;
      const params = {
        userId: this.propData.id,
        dingTalkAppIds: checkedArr
      };
      userApi.closeBind(params).then(
        res => {
          this.unBindTipLoading = false;
          if (res.success) {
            this.unBindTipVisible = false;
            this.dialogVisible = false;
            this.$message.success("解除成功!");
          }
        },
        () => {
          this.unBindTipLoading = false;
        }
      );
    },
    // 获取组织列表数据
    getList() {
      const params = {
        userId: this.propData.id
      };
      this.tableLoading = true;
      userApi.getBindDDUser(params).then(
        res => {
          this.tableLoading = false;
          if (res.data) {
            this.tableData = res.data;
          }
        },
        () => {
          this.tableLoading = false;
        }
      );
    },
    unBind() {
      // 获取选中的数据
      const checkedArr = this.$refs.EdmCustomTable.getChecked();
      if (checkedArr.length === 0) {
        this.$message.warning("请选择要解绑的账号");
        return;
      }
      this.unBindTipVisible = true;
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .self-dialog-form {
  .el-dialog__body {
    max-height: 100% !important;
    overflow-y: hidden !important;
  }
}
.btn-wrap {
  padding: 8px 0;
}
.mr16 {
  margin-right: 16px;
}
</style>
